export const OFFICE = "office";
export const CUSTOMER = "customer";
